module.exports = __webpack_public_path__ + "img/bird-8-right.2b842fad.png";